const User = (function () {
  const getUserName = (user) => {
    if (!user) return '';
    const { first_name, last_name, email, name : name_ } = user;
    let name = '';
    if (first_name || last_name || name_) {
      if (first_name) name += `${first_name}`;
      if (last_name) name += first_name ? ` ${last_name}` : last_name;
      if (name_) name += name_;
    } else name = email;
    return name;
  };

  const getInitial = (user) => {
    return getUserName(user)?.substring(0, 1).toUpperCase() || '';
  };

  return { getUserName, getInitial };
})();

export default User;
